import HeaderSubSection from "../../components/HeaderSubSection/index.vue";
import cartSection from "../../components/cartSection/index.vue";

export default {
  name: "cartPage",
  components: {
    HeaderSubSection,
    cartSection,
  },
};
